export default __webpack_public_path__ + "static/font-dc09ea116845a4c28241ac6b868b9387.woff2";